import PropTypes from 'prop-types';
import { BsPersonBadge } from 'react-icons/bs';

import Switch from '#globalComponents/Forms/Switch';

import { FACET_LABELS, facetValueLabel, vocabularyOptions } from '../../../utils/targetingLabels';

import { CollapseCard } from './CollapseCard';
import { RangeInput } from './criteriaFormAtoms';
import { MultiSelect } from './MultiSelect';

const AGE_FIELDS = ['oldestCeoAge', 'youngestCeoAge'];

const summarizeManagement = (filters, vocabulary) => {
	const bits = [];
	for (const field of AGE_FIELDS) {
		if (!filters[field]?.length) continue;
		const buckets = filters[field].map((bucket) => facetValueLabel(vocabulary, field, bucket)).join(', ');
		bits.push(`${FACET_LABELS[field]}: ${buckets}`);
	}
	if (filters.ceoCountMin || filters.ceoCountMax) {
		bits.push(`${filters.ceoCountMin || '1'}–${filters.ceoCountMax || '∞'} GF`);
	}
	if (filters.ownerLedOnly) bits.push('inhabergeführt');
	return bits.length ? bits.join(' · ') : 'Nicht gesetzt';
};

/**
 * "Geschäftsführung" card: age of the oldest and of the youngest active managing director, their
 * number, owner-led.
 */
export const ManagementCriteriaCard = ({ filters, onFilterChange, vocabulary, open, onToggle }) => (
	<CollapseCard
		icon={BsPersonBadge}
		title="Geschäftsführung"
		type="hr"
		span2
		summary={summarizeManagement(filters, vocabulary)}
		open={open}
		onToggle={onToggle}
	>
		<div className="grid grid-cols-2 gap-3">
			{AGE_FIELDS.map((field) => (
				<div key={field}>
					<label className="block text-xs text-bgBase-800 mb-1">{FACET_LABELS[field]}</label>
					<MultiSelect
						options={vocabularyOptions(vocabulary?.ageBuckets)}
						selected={filters[field] || []}
						onChange={(v) => onFilterChange(field, v)}
						placeholder="Alle Altersgruppen"
					/>
				</div>
			))}
			<div>
				<label className="block text-xs text-bgBase-800 mb-1">Anzahl Geschäftsführer</label>
				<RangeInput
					fromValue={filters.ceoCountMin}
					toValue={filters.ceoCountMax}
					onFrom={(v) => onFilterChange('ceoCountMin', v)}
					onTo={(v) => onFilterChange('ceoCountMax', v)}
					step={1}
					min={vocabulary?.limits?.ceoCountMin?.min ?? 1}
					max={vocabulary?.limits?.ceoCountMax?.max}
				/>
			</div>
		</div>
		<Switch
			size="sm"
			checked={filters.ownerLedOnly === true}
			onChange={(checked) => onFilterChange('ownerLedOnly', checked)}
			label="Nur inhabergeführt (Geschäftsführer ist zugleich Gesellschafter)"
		/>
	</CollapseCard>
);

ManagementCriteriaCard.propTypes = {
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	vocabulary: PropTypes.object,
	open: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
};
